module.exports = __webpack_public_path__ + "static/media/blogGreen.cf44c4bb.svg";